<template>
  <div class="content card-type-page">
    <!-- 搜索区（前端本地过滤，不调用后端） -->
    <el-form :inline="true" :model="searchForm" size="small" class="search-form" @submit.native.prevent>
      <el-form-item>
        <el-input
          v-model="searchForm.physicalName"
          placeholder="请输入物理卡类型"
          clearable
          style="width: 220px"
          @keyup.enter.native="handleSearch"
          @clear="handleSearch"
        />
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="searchForm.cardTypeName"
          placeholder="请输入卡品类型"
          clearable
          style="width: 220px"
          @keyup.enter.native="handleSearch"
          @clear="handleSearch"
        />
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="searchForm.simName"
          placeholder="请输入号卡类型"
          clearable
          style="width: 220px"
          @keyup.enter.native="handleSearch"
          @clear="handleSearch"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="small" icon="el-icon-search" @click="handleSearch">查询</el-button>
        <el-button size="small" icon="el-icon-refresh" @click="handleReset">重置</el-button>
        <el-button size="small" icon="el-icon-refresh" @click="handleRefresh">刷新缓存</el-button>
      </el-form-item>
    </el-form>

    <el-table
      v-loading="loading"
      :data="flatRows"
      border
      size="mini"
      class="type-table"
      :span-method="objectSpanMethod"
    >
      <el-table-column prop="physicalName" label="物理卡类型" min-width="170" align="center" />
      <el-table-column prop="cardTypeName" label="卡品类型" min-width="120" align="center" />
      <el-table-column prop="simName" label="号卡类型" min-width="130" align="center" />
    </el-table>
  </div>
</template>

<script>
import { cardTypeTree,refreshCardType } from "@/api/card";

export default {
  name: "CardType",
  data() {
    return {
      loading: false,
      searchForm: {
        physicalName: "",
        cardTypeName: "",
        simName: ""
      },
      activeFilter: {
        physicalName: "",
        cardTypeName: "",
        simName: ""
      },
      cardTypeTree: []
    };
  },
  computed: {
    // 按已生效的搜索条件过滤三级树（纯前端过滤）
    filteredTree() {
      const { physicalName, cardTypeName, simName } = this.activeFilter;
      // 模糊匹配，忽略大小写
      const match = (text, keyword) =>
        !keyword || String(text || "").toLowerCase().indexOf(String(keyword).toLowerCase()) > -1;
      return this.cardTypeTree
        .filter(p => match(p.physicalName, physicalName))
        .map(p => ({
          ...p,
          cardTypeItems: p.cardTypeItems
            .filter(item => match(item.cardTypeName, cardTypeName))
            .map(item => ({
              ...item,
              simTypes: item.simTypes.filter(s => match(s.name, simName))
            }))
            // 号卡类型被过滤空时，保留卡品行占位（父级仍在搜索结果内时）
            .filter(item => item.simTypes.length || !simName)
        }))
        .filter(p => p.cardTypeItems.length);
    },
    // 把树拍平成表格行，并预计算合并单元格所需的行数
    flatRows() {
      const rows = [];
      this.filteredTree.forEach(physical => {
        // 物理卡类型列合并的总行数 = 该物理下所有号卡行数
        let physicalTotal = 0;
        physical.cardTypeItems.forEach(item => (physicalTotal += item.simTypes.length || 1));
        let physicalFirst = true;
        physical.cardTypeItems.forEach(item => {
          const simList = item.simTypes.length ? item.simTypes : [{ id: "", name: "" }];
          simList.forEach((sim, sIdx) => {
            rows.push({
              physicalName: physical.physicalName,
              cardTypeName: item.cardTypeName,
              simId: sim.id,
              simName: sim.name,
              // 物理列合并
              physicalSpan: physicalFirst ? physicalTotal : 0,
              // 卡品列合并（空号卡列表也占一行）
              productSpan: sIdx === 0 ? simList.length : 0
            });
            physicalFirst = false;
          });
        });
      });
      return rows;
    }
  },
  methods: {
    // 加载列表
    getList() {
      this.loading = true;
      cardTypeTree()
        .then(res => {
          this.cardTypeTree = Array.isArray(res.data.data) ? res.data.data : [];
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    // 刷新缓存
    handleRefresh(){
      refreshCardType().then(res => {
        this.$message({
          message: res.data.msg || "刷新成功",
          type: "success"
        });
        this.getList();
      });
    },
    // 查询：把输入框条件设为生效条件
    handleSearch() {
      this.activeFilter = { ...this.searchForm };
    },
    // 重置：清空条件并恢复全量数据
    handleReset() {
      this.searchForm = { physicalName: "", cardTypeName: "", simName: "" };
      this.activeFilter = { physicalName: "", cardTypeName: "", simName: "" };
    },
    // 合并单元格：第0列按物理卡类型，第1列按卡品类型
    objectSpanMethod({ row, columnIndex }) {
      if (columnIndex === 0) {
        return { rowspan: row.physicalSpan, colspan: row.physicalSpan ? 1 : 0 };
      }
      if (columnIndex === 1) {
        return { rowspan: row.productSpan, colspan: row.productSpan ? 1 : 0 };
      }
      return { rowspan: 1, colspan: 1 };
    }
  },
  created() {
    this.getList();
  }
};
</script>

<style scoped>
.card-type-page {
  padding: 12px;
}
.search-form {
  margin-bottom: 6px;
}
.search-form >>> .el-form-item {
  margin-bottom: 8px;
}
/* 仅压缩行高，字体大小与颜色沿用项目 Element 默认样式 */
.type-table {
  width: 100%;
}
.type-table >>> th {
  padding: 6px 0;
}
.type-table >>> td {
  padding: 1px 0;
  font-weight: bold;
}
.type-table >>> .cell {
  line-height: 22px;
}
.op-btn.danger {
  color: #f56c6c;
}
</style>
